export const algebra2TestNY = [
  {
    id: 1,
    question: "Which expression is equivalent to (3x² - 5x + 2) - (x² + 3x - 7)?",
    options: [
      "2x² - 8x + 9",
      "2x² - 2x - 5",
      "4x² - 2x - 5",
      "2x² - 8x - 5"
    ],
    correctAnswer: 0,
    solution: "Step 1: Distribute the negative sign:\n(3x² - 5x + 2) - x² - 3x + 7\n\nStep 2: Combine like terms:\nx² terms: 3x² - x² = 2x²\nx terms: -5x - 3x = -8x\nConstants: 2 + 7 = 9\n\nStep 3: Write the final expression:\n2x² - 8x + 9\n\nAnswer: A",
    points: 2
  },
  {
    id: 2,
    question: "If f(x) = 2x³ - 5x² + 3x - 1, what is f(-2)?",
    options: [
      "-39",
      "-23",
      "17",
      "-35"
    ],
    correctAnswer: 0,
    solution: "Step 1: Substitute x = -2 into the function:\nf(-2) = 2(-2)³ - 5(-2)² + 3(-2) - 1\n\nStep 2: Evaluate each term:\n2(-2)³ = 2(-8) = -16\n-5(-2)² = -5(4) = -20\n3(-2) = -6\n-1 = -1\n\nStep 3: Add all terms:\n-16 + (-20) + (-6) + (-1) = -39\n\nAnswer: A",
    points: 2
  },
  {
    id: 3,
    question: "Solve for x: log₃(x + 5) = 4",
    options: [
      "x = 76",
      "x = 81",
      "x = 64",
      "x = 59"
    ],
    correctAnswer: 0,
    solution: "Step 1: Convert from logarithmic to exponential form:\nlog₃(x + 5) = 4 means 3⁴ = x + 5\n\nStep 2: Evaluate 3⁴:\n3⁴ = 81\n\nStep 3: Solve for x:\n81 = x + 5\nx = 81 - 5\nx = 76\n\nStep 4: Check: log₃(76 + 5) = log₃(81) = log₃(3⁴) = 4 ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 4,
    question: "What is the period of the function y = 3sin(2x)?",
    options: [
      "π",
      "2π",
      "π/2",
      "4π"
    ],
    correctAnswer: 0,
    solution: "Step 1: Identify the general form:\ny = A sin(Bx)\nwhere A = amplitude and period = 2π/|B|\n\nStep 2: Identify B in the given function:\ny = 3sin(2x)\nB = 2\n\nStep 3: Calculate the period:\nPeriod = 2π/|B| = 2π/2 = π\n\nNote: The amplitude is 3, but that doesn't affect the period.\n\nAnswer: A",
    points: 2
  },
  {
    id: 5,
    question: "Simplify: (2 + 3i)(4 - i)",
    options: [
      "11 + 10i",
      "8 - 3i",
      "5 + 2i",
      "11 - 10i"
    ],
    correctAnswer: 0,
    solution: "Step 1: Use FOIL method:\nFirst: 2 × 4 = 8\nOuter: 2 × (-i) = -2i\nInner: 3i × 4 = 12i\nLast: 3i × (-i) = -3i²\n\nStep 2: Combine:\n8 - 2i + 12i - 3i²\n\nStep 3: Remember that i² = -1:\n-3i² = -3(-1) = 3\n\nStep 4: Combine like terms:\n8 + 3 + (-2i + 12i) = 11 + 10i\n\nAnswer: A",
    points: 2
  },
  {
    id: 6,
    question: "Which function has a vertical asymptote at x = 3?",
    options: [
      "f(x) = 1/(x - 3)",
      "f(x) = 1/(x + 3)",
      "f(x) = (x - 3)/x",
      "f(x) = x/(x² - 9)"
    ],
    correctAnswer: 0,
    solution: "Step 1: Vertical asymptotes occur where the denominator equals zero (and the numerator doesn't).\n\nStep 2: Check each option:\nA) 1/(x - 3): denominator = 0 when x - 3 = 0, so x = 3 ✓\nB) 1/(x + 3): denominator = 0 when x + 3 = 0, so x = -3 ✗\nC) (x - 3)/x: denominator = 0 when x = 0 ✗\nD) x/(x² - 9) = x/[(x-3)(x+3)]: asymptotes at x = 3 and x = -3 (two asymptotes)\n\nStep 3: Only option A has a vertical asymptote at exactly x = 3.\n\nAnswer: A",
    points: 2
  },
  {
    id: 7,
    question: "If log₂(8) + log₂(4) = log₂(x), what is the value of x?",
    options: [
      "32",
      "12",
      "64",
      "16"
    ],
    correctAnswer: 0,
    solution: "Step 1: Use the logarithm product rule:\nlog_b(m) + log_b(n) = log_b(mn)\n\nStep 2: Apply the rule:\nlog₂(8) + log₂(4) = log₂(8 × 4) = log₂(32)\n\nStep 3: Since log₂(x) = log₂(32):\nx = 32\n\nStep 4: Verify:\nlog₂(8) = 3 (since 2³ = 8)\nlog₂(4) = 2 (since 2² = 4)\n3 + 2 = 5\nlog₂(32) = 5 (since 2⁵ = 32) ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 8,
    question: "What is the sum of the infinite geometric series: 12 + 6 + 3 + 1.5 + ...?",
    options: [
      "24",
      "36",
      "18",
      "The series diverges"
    ],
    correctAnswer: 0,
    solution: "Step 1: Identify the first term and common ratio:\na₁ = 12\nr = 6/12 = 1/2\n\nStep 2: Check if the series converges:\nFor convergence, |r| < 1\n|1/2| = 0.5 < 1 ✓ (converges)\n\nStep 3: Use the infinite geometric series formula:\nS = a₁/(1 - r)\n\nStep 4: Calculate:\nS = 12/(1 - 1/2) = 12/(1/2) = 12 × 2 = 24\n\nAnswer: A",
    points: 2
  },
  {
    id: 9,
    question: "Solve: 2^(x+1) = 32",
    options: [
      "x = 4",
      "x = 5",
      "x = 3",
      "x = 6"
    ],
    correctAnswer: 0,
    solution: "Step 1: Express 32 as a power of 2:\n32 = 2⁵\n\nStep 2: Rewrite the equation:\n2^(x+1) = 2⁵\n\nStep 3: Since the bases are equal, set the exponents equal:\nx + 1 = 5\n\nStep 4: Solve for x:\nx = 5 - 1 = 4\n\nStep 5: Check: 2^(4+1) = 2⁵ = 32 ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 10,
    question: "What is the amplitude of y = -5cos(3x) + 2?",
    options: [
      "5",
      "-5",
      "3",
      "2"
    ],
    correctAnswer: 0,
    solution: "Step 1: Identify the general form:\ny = A cos(Bx) + D\nwhere |A| = amplitude, period = 2π/|B|, D = vertical shift\n\nStep 2: Identify A in the given function:\ny = -5cos(3x) + 2\nA = -5\n\nStep 3: Calculate amplitude:\nAmplitude = |A| = |-5| = 5\n\nNote: Amplitude is always positive (it's the distance from the midline to the maximum or minimum).\nThe negative sign indicates a reflection, not the amplitude.\n\nAnswer: A",
    points: 2
  },
  {
    id: 11,
    question: "Factor completely: x³ - 8",
    options: [
      "(x - 2)(x² + 2x + 4)",
      "(x - 2)(x² - 2x + 4)",
      "(x + 2)(x² - 2x + 4)",
      "(x - 2)³"
    ],
    correctAnswer: 0,
    solution: "Step 1: Recognize this as a difference of cubes:\na³ - b³ = (a - b)(a² + ab + b²)\n\nStep 2: Identify a and b:\nx³ - 8 = x³ - 2³\na = x, b = 2\n\nStep 3: Apply the formula:\n(x - 2)(x² + x·2 + 2²)\n= (x - 2)(x² + 2x + 4)\n\nStep 4: Check by expanding:\n(x - 2)(x² + 2x + 4)\n= x³ + 2x² + 4x - 2x² - 4x - 8\n= x³ - 8 ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 12,
    question: "If f(x) = 3x - 2 and g(x) = x² + 1, what is (f ∘ g)(2)?",
    options: [
      "13",
      "11",
      "17",
      "15"
    ],
    correctAnswer: 0,
    solution: "Step 1: Understand composition notation:\n(f ∘ g)(2) = f(g(2))\n\nStep 2: Find g(2):\ng(2) = 2² + 1 = 4 + 1 = 5\n\nStep 3: Find f(5):\nf(5) = 3(5) - 2 = 15 - 2 = 13\n\nStep 4: Therefore:\n(f ∘ g)(2) = 13\n\nAlternative method:\nf(g(x)) = f(x² + 1) = 3(x² + 1) - 2 = 3x² + 3 - 2 = 3x² + 1\nf(g(2)) = 3(2²) + 1 = 12 + 1 = 13 ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 13,
    question: "Simplify: (x² - 9)/(x² + 6x + 9)",
    options: [
      "(x - 3)/(x + 3)",
      "(x + 3)/(x - 3)",
      "(x - 3)²/(x + 3)²",
      "1"
    ],
    correctAnswer: 0,
    solution: "Step 1: Factor the numerator (difference of squares):\nx² - 9 = (x + 3)(x - 3)\n\nStep 2: Factor the denominator (perfect square trinomial):\nx² + 6x + 9 = (x + 3)²\n\nStep 3: Write the fraction with factored form:\n[(x + 3)(x - 3)] / [(x + 3)(x + 3)]\n\nStep 4: Cancel common factors:\n(x - 3)/(x + 3)\n\nNote: x ≠ -3 (restriction from original denominator)\n\nAnswer: A",
    points: 2
  },
  {
    id: 14,
    question: "What is the solution set for |2x - 5| = 9?",
    options: [
      "{-2, 7}",
      "{2, 7}",
      "{-7, 2}",
      "{-2, -7}"
    ],
    correctAnswer: 0,
    solution: "Step 1: Set up two equations (absolute value definition):\n2x - 5 = 9  OR  2x - 5 = -9\n\nStep 2: Solve the first equation:\n2x - 5 = 9\n2x = 14\nx = 7\n\nStep 3: Solve the second equation:\n2x - 5 = -9\n2x = -4\nx = -2\n\nStep 4: Check both solutions:\nFor x = 7: |2(7) - 5| = |14 - 5| = |9| = 9 ✓\nFor x = -2: |2(-2) - 5| = |-4 - 5| = |-9| = 9 ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 15,
    question: "If sin(θ) = 3/5 and θ is in Quadrant II, what is cos(θ)?",
    options: [
      "-4/5",
      "4/5",
      "-3/5",
      "3/4"
    ],
    correctAnswer: 0,
    solution: "Step 1: Use the Pythagorean identity:\nsin²(θ) + cos²(θ) = 1\n\nStep 2: Substitute sin(θ) = 3/5:\n(3/5)² + cos²(θ) = 1\n9/25 + cos²(θ) = 1\n\nStep 3: Solve for cos²(θ):\ncos²(θ) = 1 - 9/25 = 25/25 - 9/25 = 16/25\n\nStep 4: Take the square root:\ncos(θ) = ±4/5\n\nStep 5: Determine the sign:\nIn Quadrant II, cosine is negative.\nTherefore, cos(θ) = -4/5\n\nAnswer: A",
    points: 2
  },
  {
    id: 16,
    question: "Expand: (2x - 3)³",
    options: [
      "8x³ - 36x² + 54x - 27",
      "8x³ - 27",
      "8x³ + 36x² + 54x + 27",
      "8x³ - 12x² + 18x - 27"
    ],
    correctAnswer: 0,
    solution: "Step 1: Use the binomial expansion formula:\n(a - b)³ = a³ - 3a²b + 3ab² - b³\n\nStep 2: Identify a and b:\na = 2x, b = 3\n\nStep 3: Calculate each term:\na³ = (2x)³ = 8x³\n-3a²b = -3(2x)²(3) = -3(4x²)(3) = -36x²\n3ab² = 3(2x)(3²) = 3(2x)(9) = 54x\n-b³ = -3³ = -27\n\nStep 4: Combine all terms:\n8x³ - 36x² + 54x - 27\n\nAnswer: A",
    points: 2
  },
  {
    id: 17,
    question: "What is the inverse of f(x) = (x + 4)/3?",
    options: [
      "f⁻¹(x) = 3x - 4",
      "f⁻¹(x) = 3x + 4",
      "f⁻¹(x) = (x - 4)/3",
      "f⁻¹(x) = 3/(x + 4)"
    ],
    correctAnswer: 0,
    solution: "Step 1: Replace f(x) with y:\ny = (x + 4)/3\n\nStep 2: Swap x and y:\nx = (y + 4)/3\n\nStep 3: Solve for y:\n3x = y + 4\ny = 3x - 4\n\nStep 4: Replace y with f⁻¹(x):\nf⁻¹(x) = 3x - 4\n\nStep 5: Verify by composition:\nf(f⁻¹(x)) = f(3x - 4) = [(3x - 4) + 4]/3 = 3x/3 = x ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 18,
    question: "Solve the system:\nx + y = 5\nx² + y² = 13",
    options: [
      "(2, 3) and (3, 2)",
      "(1, 4) and (4, 1)",
      "(0, 5) and (5, 0)",
      "No real solution"
    ],
    correctAnswer: 0,
    solution: "Step 1: From the first equation, solve for y:\ny = 5 - x\n\nStep 2: Substitute into the second equation:\nx² + (5 - x)² = 13\n\nStep 3: Expand:\nx² + 25 - 10x + x² = 13\n2x² - 10x + 25 = 13\n\nStep 4: Simplify:\n2x² - 10x + 12 = 0\nx² - 5x + 6 = 0\n\nStep 5: Factor:\n(x - 2)(x - 3) = 0\nx = 2 or x = 3\n\nStep 6: Find corresponding y values:\nIf x = 2: y = 5 - 2 = 3 → (2, 3)\nIf x = 3: y = 5 - 3 = 2 → (3, 2)\n\nStep 7: Verify both solutions in x² + y² = 13:\n2² + 3² = 4 + 9 = 13 ✓\n3² + 2² = 9 + 4 = 13 ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 19,
    question: "What is the remainder when x³ - 2x² + 5x - 7 is divided by (x - 2)?",
    options: [
      "3",
      "-7",
      "5",
      "1"
    ],
    correctAnswer: 0,
    solution: "Step 1: Use the Remainder Theorem:\nWhen P(x) is divided by (x - a), the remainder is P(a).\n\nStep 2: Here, we're dividing by (x - 2), so a = 2.\nFind P(2):\n\nStep 3: Substitute x = 2:\nP(2) = (2)³ - 2(2)² + 5(2) - 7\n     = 8 - 2(4) + 10 - 7\n     = 8 - 8 + 10 - 7\n     = 3\n\nStep 4: Therefore, the remainder is 3.\n\nAnswer: A",
    points: 2
  },
  {
    id: 20,
    question: "Simplify: √(-16) · √(-9)",
    options: [
      "-12",
      "12",
      "12i",
      "-12i"
    ],
    correctAnswer: 0,
    solution: "Step 1: Express each square root in terms of i:\n√(-16) = √(16 · -1) = √16 · √(-1) = 4i\n√(-9) = √(9 · -1) = √9 · √(-1) = 3i\n\nStep 2: Multiply:\n√(-16) · √(-9) = 4i · 3i = 12i²\n\nStep 3: Remember that i² = -1:\n12i² = 12(-1) = -12\n\nImportant note: √(a) · √(b) = √(ab) only when at least one of a or b is non-negative.\nFor negative numbers, we must convert to i form first.\n\nAnswer: A",
    points: 2
  },
  {
    id: 21,
    question: "What is the domain of f(x) = √(x - 3) + 2?",
    options: [
      "x ≥ 3",
      "x > 3",
      "x ≥ -3",
      "All real numbers"
    ],
    correctAnswer: 0,
    solution: "Step 1: For a square root function to be defined (in real numbers), the radicand must be non-negative.\n\nStep 2: Set up the inequality:\nx - 3 ≥ 0\n\nStep 3: Solve for x:\nx ≥ 3\n\nStep 4: The +2 outside the square root doesn't affect the domain.\n\nStep 5: Therefore, the domain is x ≥ 3 or [3, ∞) in interval notation.\n\nAnswer: A",
    points: 2
  },
  {
    id: 22,
    question: "If log(x) = 3, what is log(x²)?",
    options: [
      "6",
      "9",
      "3",
      "12"
    ],
    correctAnswer: 0,
    solution: "Step 1: Use the logarithm power rule:\nlog(x^n) = n · log(x)\n\nStep 2: Apply to log(x²):\nlog(x²) = 2 · log(x)\n\nStep 3: Substitute log(x) = 3:\nlog(x²) = 2 · 3 = 6\n\nAlternative verification:\nIf log(x) = 3, then x = 10³ = 1000\nx² = 1000² = 1,000,000 = 10⁶\nlog(10⁶) = 6 ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 23,
    question: "What is the 5th term of the arithmetic sequence: 7, 12, 17, 22, ...?",
    options: [
      "27",
      "32",
      "37",
      "42"
    ],
    correctAnswer: 0,
    solution: "Step 1: Identify the first term and common difference:\na₁ = 7\nd = 12 - 7 = 5\n\nStep 2: Use the arithmetic sequence formula:\naₙ = a₁ + (n - 1)d\n\nStep 3: Find the 5th term (n = 5):\na₅ = 7 + (5 - 1)(5)\n   = 7 + 4(5)\n   = 7 + 20\n   = 27\n\nStep 4: Verify by listing:\n1st term: 7\n2nd term: 12\n3rd term: 17\n4th term: 22\n5th term: 27 ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 24,
    question: "Simplify: (3i)² - 2i + 5",
    options: [
      "-4 - 2i",
      "14 - 2i",
      "4 - 2i",
      "-4 + 2i"
    ],
    correctAnswer: 0,
    solution: "Step 1: Evaluate (3i)²:\n(3i)² = 9i² = 9(-1) = -9\n\nStep 2: Substitute into the expression:\n-9 - 2i + 5\n\nStep 3: Combine real parts:\n-9 + 5 = -4\n\nStep 4: Write in standard form a + bi:\n-4 - 2i\n\nAnswer: A",
    points: 2
  },
  {
    id: 25,
    question: "What is the range of f(x) = -2(x - 3)² + 5?",
    options: [
      "y ≤ 5",
      "y ≥ 5",
      "y ≤ -5",
      "All real numbers"
    ],
    correctAnswer: 0,
    solution: "Step 1: Identify the function type:\nThis is a quadratic function in vertex form: f(x) = a(x - h)² + k\n\nStep 2: Identify the vertex and direction:\nVertex: (h, k) = (3, 5)\na = -2 (negative, so parabola opens downward)\n\nStep 3: Determine the range:\nSince the parabola opens downward, the vertex is the maximum point.\nMaximum value: y = 5\n\nStep 4: The function can take any value less than or equal to 5.\nRange: y ≤ 5 or (-∞, 5] in interval notation\n\nAnswer: A",
    points: 2
  },
  {
    id: 26,
    question: "Solve: e^(2x) = 7",
    options: [
      "x = ln(7)/2",
      "x = 2ln(7)",
      "x = ln(14)",
      "x = 7/2"
    ],
    correctAnswer: 0,
    solution: "Step 1: Take the natural logarithm of both sides:\nln(e^(2x)) = ln(7)\n\nStep 2: Use the logarithm power rule:\n2x · ln(e) = ln(7)\n\nStep 3: Remember that ln(e) = 1:\n2x · 1 = ln(7)\n2x = ln(7)\n\nStep 4: Solve for x:\nx = ln(7)/2\n\nAlternative form: x = (1/2)ln(7) = ln(7^(1/2)) = ln(√7)\n\nAnswer: A",
    points: 2
  },
  {
    id: 27,
    question: "What is the exact value of sin(π/6)?",
    options: [
      "1/2",
      "√3/2",
      "√2/2",
      "1"
    ],
    correctAnswer: 0,
    solution: "Step 1: Recognize π/6 as a special angle:\nπ/6 radians = 30°\n\nStep 2: Recall the special right triangle (30-60-90):\nSides are in ratio 1 : √3 : 2\n\nStep 3: In a 30-60-90 triangle:\nsin(30°) = opposite/hypotenuse = 1/2\n\nStep 4: Therefore:\nsin(π/6) = 1/2\n\nMemory aid for special angles:\nsin(π/6) = 1/2\nsin(π/4) = √2/2\nsin(π/3) = √3/2\n\nAnswer: A",
    points: 2
  },
  {
    id: 28,
    question: "Simplify: (x³y²)/(x²y⁵) for x ≠ 0, y ≠ 0",
    options: [
      "x/y³",
      "x²/y³",
      "xy³",
      "x/y²"
    ],
    correctAnswer: 0,
    solution: "Step 1: Use the quotient rule for exponents:\nx^m / x^n = x^(m-n)\n\nStep 2: Apply to x terms:\nx³/x² = x^(3-2) = x¹ = x\n\nStep 3: Apply to y terms:\ny²/y⁵ = y^(2-5) = y^(-3) = 1/y³\n\nStep 4: Combine:\n(x³y²)/(x²y⁵) = x · (1/y³) = x/y³\n\nAnswer: A",
    points: 2
  },
  {
    id: 29,
    question: "What is the vertex of the parabola y = x² - 6x + 11?",
    options: [
      "(3, 2)",
      "(-3, 2)",
      "(3, -2)",
      "(6, 11)"
    ],
    correctAnswer: 0,
    solution: "Step 1: Use the vertex formula for y = ax² + bx + c:\nx-coordinate of vertex: h = -b/(2a)\n\nStep 2: Identify a, b, c:\na = 1, b = -6, c = 11\n\nStep 3: Calculate h:\nh = -(-6)/(2·1) = 6/2 = 3\n\nStep 4: Calculate k by substituting x = 3:\nk = (3)² - 6(3) + 11\n  = 9 - 18 + 11\n  = 2\n\nStep 5: Vertex is (h, k) = (3, 2)\n\nAlternative: Complete the square:\ny = x² - 6x + 11\n  = (x² - 6x + 9) + 11 - 9\n  = (x - 3)² + 2\nVertex: (3, 2) ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 30,
    question: "If tan(θ) = 2 and θ is in Quadrant III, what is sin(θ)?",
    options: [
      "-2/√5 or -2√5/5",
      "2/√5 or 2√5/5",
      "-1/√5 or -√5/5",
      "1/√5 or √5/5"
    ],
    correctAnswer: 0,
    solution: "Step 1: Use the identity tan(θ) = opposite/adjacent:\nIf tan(θ) = 2, we can use a reference triangle with opposite = 2, adjacent = 1\n\nStep 2: Find the hypotenuse using Pythagorean theorem:\nhypotenuse = √(2² + 1²) = √(4 + 1) = √5\n\nStep 3: Calculate sin(θ) for the reference angle:\nsin(reference) = opposite/hypotenuse = 2/√5\n\nStep 4: Determine the sign:\nIn Quadrant III, sine is negative.\nTherefore, sin(θ) = -2/√5\n\nStep 5: Rationalize (optional):\n-2/√5 = -2/√5 · √5/√5 = -2√5/5\n\nAnswer: A",
    points: 2
  }
];